import { AiChat } from 'src/@types/ai';
import { StoreApi, UseBoundStore, create } from 'zustand';
import {
  AIInputState,
  createStore,
} from '../components/AIInput/useAIInputState';

interface ChatIAState {
  // Add state properties here as needed
  currentConversation: AiChat | undefined;
  currentConversationId: string | undefined;
  conversationListOpen: boolean;
  conversationList: Record<string, AiChat>;
  newConversationControl: UseBoundStore<StoreApi<AIInputState>>;
  inputControlList: Record<string, UseBoundStore<StoreApi<AIInputState>>>;
}

interface ChatIAActions {
  setCurrentConversation: (currentConversation: AiChat | undefined) => void;
  setCurrentConversationId: (currentConversationId: string | undefined) => void;
  setConversationListOpen: (conversationListOpen: boolean) => void;
  setConversation: (conversation: AiChat) => void;
  setInputControl: (id: string, isNew?: boolean) => void;
}

export const chatIAState = create<ChatIAState & ChatIAActions>((set, get) => ({
  currentConversation: undefined,
  currentConversationId: undefined,
  conversationListOpen: true,
  conversationList: {},
  newConversationControl: createStore(),
  setCurrentConversationId: (currentConversationId) =>
    set({ currentConversationId }),
  setCurrentConversation: (currentConversation) => set({ currentConversation }),
  setConversationListOpen: (conversationListOpen) =>
    set({ conversationListOpen }),
  setConversation: (conversation) => {
    set((state) => ({
      conversationList: {
        ...state.conversationList,
        [conversation._id]: conversation,
      },
    }));
  },
  inputControlList: {},
  setInputControl: (id, isNew) =>
    set((state) => ({
      inputControlList: {
        ...state.inputControlList,
        [id]: isNew
          ? state.newConversationControl
          : state.inputControlList[id] || createStore(),
      },
    })),
}));
